module.exports = __webpack_public_path__ + "pc/img/work2.3ea37a83.jpg";